/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/
 */

export const shouldUpdateScroll = () => {
  window.scrollTo(0, 0)
  return false
}
